import React from 'react';
import touch from './touch_button.mp3';

// ButtonWithSound Component
const ButtonWithSound = ({button, label, onClick, className}) => {
    // sleep function returns a promise that resolves after a given time
    function sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    const handleClick = async () => {
        // Play sound
        const sound = new Audio(touch);
        sound.play();

        // Wait for the sound to finish or for a delay (optional)
        await sleep(500); // 500ms delay before executing onClick actions

        // Run other onClick actions (if any)
        if (onClick) {
            onClick();
        }
    };

    return (
        <>
            {button ? 
                <button onClick={handleClick} className={className}>
                    {label}
                </button>
                :
                <div onClick={handleClick} className={className}>
                    <div className='text'>{label}</div>
                </div>
            }
        </>
    );
};

const CheckmarkWithSound = ({onClick, className, img}) => {
    // sleep function returns a promise that resolves after a given time
    function sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    const handleClick = async () => {
        // Play sound
        const sound = new Audio(touch);
        sound.play();

        // Wait for the sound to finish or for a delay (optional)
        await sleep(500); // 500ms delay before executing onClick actions

        // Run other onClick actions (if any)
        if (onClick) {
            onClick();
        }
    };

    return (
        <div onClick={handleClick} className={className}>
            <img alt='icon' src={img} />
        </div>
    );
};

export {ButtonWithSound, CheckmarkWithSound};
